import oldSession from './oldSession';
import keycloakSession from './keycloakSession';
import { KEYCLOAK_DISABLED } from '../../config';

const session = KEYCLOAK_DISABLED ? oldSession : keycloakSession;

export default session;
